export const GROUP_MAX = 500
export const SUB_GROUP_MAX = 200

export const GROUP_TITLE_TEXT_MAX = 50
export const SUB_GROUP_TITLE_TEXT_MAX = 50
